import CustomButton from "Components/Custom/CustomButton";
import Icon from "Components/Icons/Icon";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { ClientsPayloadData } from "types/client.api";
import { getTwoLetters } from "utils/utils";

interface ClientInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  client: ClientsPayloadData;
  onViewProfileClick: () => void;
  isFromClientDetailsPage?: boolean;
}

const ClientInfoModal = ({
  isOpen,
  onClose,
  client,
  onViewProfileClick,
  isFromClientDetailsPage = false,
}: ClientInfoModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      centered
      size="md"
      contentClassName="br-7"
    >
      {/* Header */}
      <ModalHeader toggle={onClose} className="bg-greyF5  p-3">
        Client Details
      </ModalHeader>

      {/* Body */}
      <ModalBody className="p-4">
        {/* TOP CLIENT SECTION */}
        <div className="d-flex align-items-center gap-3 mb-4">
          {/* Avatar */}
          <div
            style={{
              width: 48,
              height: 48,
              minWidth: 48,
              minHeight: 48,
              borderRadius: 7,
              backgroundColor: "#ECF0FE",
              display: "grid",
              placeItems: "center",
              flexShrink: 0,
            }}
          >
            <div className="fw-medium fs-14 text-blue">
              {getTwoLetters(client.name)}
            </div>
          </div>
          {/* Name + Company */}
          <div>
            <div
              className="fw-medium fs-16 text-black2D "
              style={{
                display: "-webkit-box",
                WebkitLineClamp: 4,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                overflowWrap: "anywhere",
                wordBreak: "break-word",
              }}
            >
              {client.name}
            </div>
            <div
              className="fw-normal fs-14 text-grey89"
              style={{
                display: "-webkit-box",
                WebkitLineClamp: 4,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                overflowWrap: "anywhere",
                wordBreak: "break-word",
              }}
            >
              {client.company_name}
            </div>
          </div>
        </div>

        {/* INFO LIST */}
        <div className="d-flex flex-column gap-3">
          {/* Email */}
          <div className="d-flex align-items-center gap-2">
            <Icon name="Email" />
            <span className="fw-normal fs-14 text-black2D">{client.email}</span>
          </div>

          {/* Phone */}
          <div className="d-flex align-items-center gap-2">
            <Icon name="Phone" />
            <span className="fw-normal fs-14 text-black2D">{client.phone}</span>
          </div>

          {/* Address */}
          <div className="d-flex align-items-start gap-2">
            {/* ICON */}
            <div style={{ flexShrink: 0, marginTop: 2 }}>
              <Icon name="Location" />
            </div>

            {/* TEXT */}
            <span
              className="fw-normal fs-14 text-black2D"
              style={{
                flex: 1,
                minWidth: 0,
                display: "-webkit-box",
                WebkitLineClamp: 6,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                overflowWrap: "anywhere",
                wordBreak: "break-word",
              }}
            >
              {client.address}
            </span>
          </div>
        </div>

        {/* Divider */}
        <div className="my-3 mx-n4 dashed" />

        {/* BUTTON */}
        <CustomButton
          className="bg-primary text-white br-7"
          type="button"
          text={isFromClientDetailsPage ? "Got It!" : "View Profile"}
          onClick={isFromClientDetailsPage ? onClose : onViewProfileClick}
        />
      </ModalBody>
    </Modal>
  );
};

export default ClientInfoModal;
